import { useTenant } from "./useTenant";
import { FeatureFlagKey as EncampFeatureFlagKey } from "encamp-shared/src/featureFlags";

export function useFeatureFlags(): {
  featureFlags: FeatureFlags | undefined;
  loading: boolean;
} {
  const { tenant, loading } = useTenant();
  return { featureFlags: tenant?.featureFlags, loading };
}

export type FeatureFlagKey =
  | "amazon-notion-training"
  | "appcues-widget"
  | "chemicals-overview"
  | "countable-items-ui"
  | "eager-beaver"
  | "facility-self-assignment"
  | "insights-ui"
  | "module-tierii"
  | "module-waste"
  | "payments-update"
  | "submissions"
  | "waste-details"
  | "waste-overview"
  | EncampFeatureFlagKey;

export type FeatureFlags = Record<FeatureFlagKey, boolean>;
